"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconImage = exports.iconsSvg = void 0;
/* eslint-disable global-require */
const react_1 = __importDefault(require("react"));
const Icons_1 = require("../stages/Atoms/Icons");
exports.iconsSvg = {
    UnknownSmall: react_1.default.createElement(Icons_1.Unknown, null),
    Unknown: react_1.default.createElement(Icons_1.Unknown, { width: "25", height: "31" }),
    UnknownSelected: react_1.default.createElement(Icons_1.Unknown, { width: "36", height: "44" }),
    Ultrafast: {
        AvailableSmall: react_1.default.createElement(Icons_1.Ultrafast, null),
        Available: react_1.default.createElement(Icons_1.Ultrafast, { width: "25", height: "31" }),
        AvailableSelected: react_1.default.createElement(Icons_1.Ultrafast, { width: "36", height: "44" }),
        ChargingSmall: react_1.default.createElement(Icons_1.UltrafastCharging, null),
        Charging: react_1.default.createElement(Icons_1.UltrafastCharging, { width: "25", height: "31" }),
        ChargingSelected: react_1.default.createElement(Icons_1.UltrafastCharging, { width: "36", height: "44" }),
    },
    Fast: {
        AvailableSmall: react_1.default.createElement(Icons_1.Fast, null),
        Available: react_1.default.createElement(Icons_1.Fast, { width: "25", height: "31" }),
        AvailableSelected: react_1.default.createElement(Icons_1.Fast, { width: "36", height: "44" }),
        ChargingSmall: react_1.default.createElement(Icons_1.FastCharging, null),
        Charging: react_1.default.createElement(Icons_1.FastCharging, { width: "25", height: "31" }),
        ChargingSelected: react_1.default.createElement(Icons_1.FastCharging, { width: "36", height: "44" }),
    },
    Rapid: {
        AvailableSmall: react_1.default.createElement(Icons_1.Rapid, null),
        Available: react_1.default.createElement(Icons_1.Rapid, { width: "25", height: "31" }),
        AvailableSelected: react_1.default.createElement(Icons_1.Rapid, { width: "36", height: "44" }),
        ChargingSmall: react_1.default.createElement(Icons_1.RapidCharging, null),
        Charging: react_1.default.createElement(Icons_1.RapidCharging, { width: "25", height: "31" }),
        ChargingSelected: react_1.default.createElement(Icons_1.RapidCharging, { width: "36", height: "44" }),
    },
    Standard: {
        AvailableSmall: react_1.default.createElement(Icons_1.Standard, null),
        Available: react_1.default.createElement(Icons_1.Standard, { width: "25", height: "31" }),
        AvailableSelected: react_1.default.createElement(Icons_1.Standard, { width: "36", height: "44" }),
        ChargingSmall: react_1.default.createElement(Icons_1.StandardCharging, null),
        Charging: react_1.default.createElement(Icons_1.StandardCharging, { width: "25", height: "31" }),
        ChargingSelected: react_1.default.createElement(Icons_1.StandardCharging, { width: "36", height: "44" }),
    },
};
exports.getIconImage = (available, type, itemId, selectedChargepoint, small) => {
    if (small) {
        if (available === 'Unknown' ||
            available === 'Unavailable' ||
            type === '' ||
            !available) {
            return exports.iconsSvg.UnknownSmall;
        }
        if (available === 'Available') {
            return exports.iconsSvg[type].AvailableSmall;
        }
        return exports.iconsSvg[type].ChargingSmall;
    }
    if (available === 'Unknown' || available === 'Unavailable' || !type) {
        if (itemId === selectedChargepoint)
            return exports.iconsSvg.UnknownSelected;
        return exports.iconsSvg.Unknown;
    }
    if (itemId === selectedChargepoint) {
        if (available === 'Available') {
            return exports.iconsSvg[type].AvailableSelected;
        }
        return exports.iconsSvg[type].ChargingSelected;
    }
    if (available === 'Available') {
        return exports.iconsSvg[type].Available;
    }
    return exports.iconsSvg[type].Charging;
};
